import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './OccurrenceChildList.html?raw';
// NOTE (JS2TS): dropped dead dep dojo/date/locale (not used — date formatting delegates to occurrenceHome.occurrenceList).
// xstyle/css!./OccurrenceList.css was already commented out. Tabulator = runtime global; DOM-heavy → dom-construct aliased.
declare const Tabulator: any;
const domConstruct: any = domConstructTyped;

class OccurrenceChildList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    occurrenceID: any = null;
    occurrence: any = null;
    occurrenceForm: any = null;
    entitylist: any = [];

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(data?: any): void {
        super.startup.apply(this, arguments as any);
        console.log("occurencechildlist startup", data, this.occurrence);
        if (typeof (data) != "undefined") {
            this._onLoadChildOccurrencesResponse(data);
        }

        this.setNewButtonVisibility();
    }

    setNewButtonVisibility(bOverrideBoolValue?: any): any {
        var actualValue = false;

        if (bOverrideBoolValue === true || bOverrideBoolValue === false) {
            actualValue = bOverrideBoolValue;
        } else if (this.occurrence != null) {
            actualValue = this.occurrence.canCreateChild == true;
        } else {

        }

        if (actualValue === true) {
            domClass.remove(this.btnNewChild, "w3-hide");
        } else {
            domClass.add(this.btnNewChild, "w3-hide");
        }

        return actualValue;
    }

    loadChildOccurrences(): void {

        this.entitylist = [];

        this.StandbyStart();

        var url = window.appRoot + "JDM/LoadChildOccurrences";

        if (this.occurrenceID == null || typeof (this.occurrenceID) == "undefined") {
            return;
        }

        this.RequestManager.post(
            url,
            {
                occurrenceID: this.occurrenceID
            },
            lang.hitch(this, "_onLoadChildOccurrencesResponse"),
            lang.hitch(this, "_onLoadChildOccurrencesError"),
            false // sync
        );
    }

    _onLoadChildOccurrencesResponse(entitylist: any): void {
        this.StandbyStop();

        this.entitylist = entitylist;
        console.log("_onLoadChildOccurrencesResponse", entitylist);

        if (entitylist.length > 0) {
            domClass.remove(this.sectionChildlist, "w3-hide");
        } else {
            if (this.setNewButtonVisibility() === true) {
                domClass.add(this.sectionChildlist, "w3-hide");
            } else {
                domClass.remove(this.sectionChildlist, "w3-hide");
                domConstruct.empty(this.sectionChildlist);
                domConstruct.create("div", {
                    style: {
                        "fontStyle": "italic"
                    },
                    className: "w3-text-gray",
                    "innerHTML": this.translations["General_noEntries"]//"keine Einträge"
                }, this.sectionChildlist)
            }
        }

        domStyle.set(this.childlistContainer, "fontSize", "12px");

        // employeeTasksContainer
        this.COTable = new Tabulator(this.childlistContainer, {
            data: entitylist,
            selectableCheck: lang.hitch(this, "tableSelectableCheck"),
            rowClick: lang.hitch(this, "clickRow"),
            layout: "fitColumns",
            height: "100px",
            //tableBuilt: lang.hitch(this, this._onTableLoaded),
            columns: [
                { title: this.translations["OccurrenceList__TableCol_Number"]/*"Nummer"*/, field: "Number", width: 90, editor: false },
                { title: this.translations["OccurrenceList__TableCol_ReportingDate"]/*"Datum"*/, field: "Time", width: 110, editor: false, formatter: lang.hitch((document as any).occurrenceHome.occurrenceList, "tableFormatterDateTime") },
                { title: this.translations["OccurrenceList__TableCol_Reporter"]/*"Meldender"*/, field: "ref_reporter.DispName", width: 120, editor: false },
                { title: this.translations["OccurrenceList__TableCol_Requesttype"]/*"Meldungsart"*/, field: "ref_occurrence_type.Name", width: 200, editor: false },
                { title: this.translations["OccurrenceList__TableCol_Costcenter"]/*"Kostenstelle"*/, field: "ref_cost_center2_reported.Cost_center", /*width: 100,*/ editor: false },
                { title: this.translations["OccurrenceList__TableCol_OccurrenceStatus"]/*"Status"*/, field: "ref_occurrence_status.description", /*width: 100,*/ editor: false, formatter: lang.hitch((document as any).occurrenceHome.occurrenceList, "tableFormatterStatus") }


            ]
            //rowFormatter: lang.hitch(this, "_appendNestedTable"),
        });

        //domStyle.set(this.childlistContainer, "height", "unset");



    }

    tableSelectableCheck(row: any): any {
        return true;
    }

    clickRow(evt: any, row: any): void {

        var data = row.getData();

        var entityID = data.web_guid;

        var occHome = (document as any).occurrenceHome;
        var dlg = occHome.showOccurrenceDialog(entityID, true); // Schreibschutz true
    }

    //custom formatter definition
    tableBtnActions(cell: any, formatterParams: any, onRendered: any): any { //plain text value

        var data = cell.getRow().getData();

        var container = domConstruct.create("div");
        //console.log("tableBtnActions", data, buttonStates);

        // Button zum Aufklappen der Ausführungen
        //if (false) {
        //    var button = domConstruct.create("div");
        //    domClass.add(button, "w3-padding-small w3-center w3-margin-left mds-bg-gray mds-hover-dark w3-cell");
        //    domAttr.set(button, "innerHTML", "<i class='fa fa-eye'>&nbsp;</i>");
        //    domAttr.set(button, "title", "anzeigen");
        //    domConstruct.place(button, container);
        //    on(button, "click", lang.hitch(this, "_onClick__SwitchToOccurrenceExecutor", data.ID));
        //}

        if (true) {//(this._isEditor == true) {
            var button = domConstruct.create("div");
            domClass.add(button, "w3-padding-small w3-center mds-bg-gray mds-hover-dark");
            domAttr.set(button, "innerHTML", "<i class='fa fa-external-link-square'></i>" + this.translations["OccurrenceList__TableBtn_Show"]);
            domAttr.set(button, "title", this.translations["OccurrenceList__TableBtn_ShowTooltip"]);//"Meldung öffnen");
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "clickTableOpen", cell));

            //console.log("editbutton", button);
        }

        return container;

    }

    clickTableOpen(cell: any, evt: any): void {
        console.log("clickTableOpen", cell, evt);
        var row = cell.getRow();
        this.clickRow(evt, row);

        evt.stopPropagation();
    }

    _onClick_NewChild(evt?: any): void {
        var occHome = (document as any).occurrenceHome;
        var dlg = occHome.showOccurrenceDialog();
        //console.log("new child", this.occurrenceForm);
        //dlg.occurrenceForm.inputOccurrenceType.selectedValue = "000081a5:0000002c"; // da könnte man doch sicher was mitm Translationmanager machen :D
        dlg.occurrenceForm._parentRoomSelection = {
            building: this.occurrenceForm.selectedBuildingID,
            buildingpart: this.occurrenceForm.selectedBuildingPartID,
            level: this.occurrenceForm.selectedLevelID,
            room: this.occurrenceForm.selectedRoomID,
            _label: domAttr.get(this.occurrenceForm.labelRoom, "value")
        };

        dlg.occurrenceForm.setMainOccurrence(this.occurrence);
        domAttr.set(dlg.headerNode, "innerHTML", /*"Folgemeldung erfassen"*/this.translations["OccurrenceHome__NewDialog_HeaderChild"] + " - " + this.occurrence.Number);
        on(dlg, "EntitySaved", lang.hitch(this, "_onChildEntitySaved"));
    }

    _onChildEntitySaved(): void {
        console.log("_onChildEntitySaved", this.domNode);
        this.loadChildOccurrences();
    }

    _onLoadChildOccurrencesError(error: any): void {
        this.StandbyStop();
    }


    tableFormatterStatus(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        var rawColor = data.ref_occurrence_status.Coloration;

        if (rawColor == null || typeof (rawColor) == "undefined") {
            return value;
        }

        var rawTextColor = "000000";

        if (rawColor.indexOf(":") > -1) {
            rawColor = data.ref_occurrence_status.Coloration.split(":")[1];
            rawTextColor = data.ref_occurrence_status.Coloration.split(":")[0];
        } else {
            rawColor = data.ref_occurrence_status.Coloration;
        }


        if (rawColor.length == 6) {
            var hexColor = rawColor.slice(4) + rawColor.slice(2, 4) + rawColor.slice(0, 2);

            domStyle.set(cell.getElement(), "background-color", "#" + hexColor);
        }

        if (rawTextColor.length == 6) {
            var hexColor: any = rawTextColor.slice(4) + rawTextColor.slice(2, 4) + rawTextColor.slice(0, 2);

            domStyle.set(cell.getElement(), "color", "#" + hexColor);
        }

        // pit-Farbe wird in BGR zurückgegeben. ganz toll.
        // aabbcc:ddeeff der hintere Teil interessiert uns

        return value;
    }
}
OccurrenceChildList.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceChildList';

export default mdsWidget(OccurrenceChildList);
